import { render } from "./Compras.vue?vue&type=template&id=3f0f10d8&scoped=true"
import script from "./Compras.vue?vue&type=script&lang=js"
export * from "./Compras.vue?vue&type=script&lang=js"

import "./Compras.vue?vue&type=style&index=0&id=3f0f10d8&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0f10d8"]])

export default __exports__